<div class="col-12">

  <p-table 
    [value]="donorNotes" 
    dataKey="id" 
    styleClass="datatable-sm"
    [scrollable]="true" 
    scrollHeight="400px">

      <ng-template pTemplate="header">
        <tr>
          <th>Date</th>
          <th>Note</th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-donorNoteItem let-expanded="expanded">
        <tr>
          <td>{{ donorNoteItem.createdDate | date : 'M/d/yyyy' }}</td>
          <td>{{ donorNoteItem.note }}</td>
          <td>
            <rc-generic-button label="Edit" iconImg="cog" iconColor="teal-light" [isIconOnly]="true" [classes]="['table-action-btn']" data-cy="btn-edit"
              (clickHandler)="onAddEditDonorNote(donorNoteItem)" />
            <rc-generic-button label="Delete" iconImg="trash" iconColor="red-light" [isIconOnly]="true" data-cy="btn-delete"
              [classes]="['table-action-btn']" (clickHandler)="onDeleteDonorNote(donorNoteItem)" />
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage" *ngIf="donorNotes.length==0">
        <tr>
          <td [attr.colspan]="4" style="text-align: center;">
            There are no notes for this donor.
          </td>
        </tr>
      </ng-template>
    </p-table>
    <div class="flex justify-content-end mt-2">
      <rc-generic-button label="Add New Note" iconImg="plus" borderStyle="text-only" level="secondary" size="small" [classes]="['mx-1']" 
        (clickHandler)="onAddEditDonorNote()" />
    </div>
</div>

<!-- Add Donor Note MODAL -->
<div id="add-donor-note-card" data-cy="add-donor-note-card">
  <p-dialog [(visible)]="showAddEditNoteDialog"
    [header]="(isEditMode ? 'Edit' : 'Add New') + ' Note'" 
    [modal]="true"
    styleClass="p-dialog-static p-dialog-sm fadeinright animation-duration-300" >

    <form [formGroup]="donorNoteFormGroup">
      <div>
        <div class="formgrid">          
          <div class="field">
            <label for="donorNoteTypeId" class="field-label required">Note Type</label>
            
            <p-dropdown formControlName="donorNoteTypeId" id="donorNoteTypeId" 
                        [options]="donorNoteTypes" optionLabel="value" optionValue="key"
                        placeholder="Please Select" />
            <div *ngIf="donorNoteFormGroup.controls['donorNoteTypeId'].invalid && donorNoteFormGroup.controls['donorNoteTypeId'].touched" class="block p-error">
              <small id="donorNoteType-error" class="error"> Please select note type. </small>
            </div>
          </div>
          <div class="field">
            <label for="note" class="field-label required">Note Text</label>
            <textarea id="note" formControlName="note" rows="5" pInputTextarea
              class="p-inputtextarea p-inputtext p-component p-element"></textarea>
          </div>
        </div>
      </div>
    </form>

    <ng-template pTemplate="footer">
      <p-button 
          label="Cancel" 
          [text]="true" 
          (onClick)="closeAddEditDialog()" />
      <p-button 
          label="Save" 
          (onClick)="saveDonorNote()" />
  </ng-template>

  </p-dialog>
</div>

<rc-generic-confirmation
  [visible]="showDeleteNoteDialog"
  title="Delete Note"
  message="Are you sure you want to delete this note?"
  confirmText="Delete"
  cancelText="Cancel"
  [dataObject]="donorNoteToDelete"
  (onConfirm)="onDeleteDonorNoteConfirm($event)"
  (onCancel)="onDeleteDonorNoteCancel()" />
